import gql from 'graphql-tag';

export default gql`
  mutation passwordResetMutation($input: AgentResetPasswordInput) {
    agentsResetOnePassword(input: $input)
  }
`;
